/** DataBest — Dictionaries admin page (prohibited + preferred words). */
import React, { useState } from "react";
import CrudPage from "@/components/CrudPage";
import { dictionariesApi } from "@/lib/scoringApi";

// Adapt to CrudPage's api shape
const wordsApi = {
    list: (params) => dictionariesApi.listWords(params),
    get: (id) => dictionariesApi.listWords().then((rows) => rows.find((r) => r.id === id)),
    create: (data) => dictionariesApi.createWord(data),
    update: (id, data) => dictionariesApi.updateWord(id, data),
    remove: (id) => dictionariesApi.deleteWord(id),
};

const DictionariesPage = () => {
    const [tab, setTab] = useState("prohibited");
    return (
        <div data-testid="dictionaries-page">
            <div className="mb-4 flex gap-2">
                {[
                    { k: "prohibited", label: "Prohibited words" },
                    { k: "preferred", label: "Preferred words" },
                ].map((t) => (
                    <button
                        key={t.k}
                        onClick={() => setTab(t.k)}
                        data-testid={`dict-tab-${t.k}`}
                        className={`rounded-full px-4 py-1.5 text-sm font-semibold ${
                            tab === t.k
                                ? "bg-brand-blue-700 text-white"
                                : "bg-white text-slate-600 border border-slate-200"
                        }`}
                    >
                        {t.label}
                    </button>
                ))}
            </div>
            <CrudPage
                key={tab}
                title={tab === "prohibited" ? "Prohibited Words" : "Preferred Words"}
                subtitle={
                    tab === "prohibited"
                        ? "Words caregivers should not use in comments. 'block' prevents saving; 'warn' only alerts."
                        : "Preferred vocabulary suggested by the platform when a prohibited word is detected."
                }
                api={wordsApi}
                listParams={{ category: tab }}
                testidPrefix="words"
                columns={[
                    { key: "word", label: "Word" },
                    { key: "category", label: "Category" },
                    { key: "action", label: "Action" },
                    {
                        key: "active",
                        label: "Status",
                        render: (r) =>
                            r.active ? (
                                <span className="rounded-full bg-brand-green-100 px-2.5 py-1 text-xs font-semibold text-brand-green-800">
                                    Active
                                </span>
                            ) : (
                                <span className="rounded-full bg-slate-200 px-2.5 py-1 text-xs font-semibold text-slate-600">
                                    Inactive
                                </span>
                            ),
                    },
                ]}
                fields={[
                    { name: "word", label: "Word or phrase", required: true },
                    {
                        name: "category",
                        label: "Category",
                        type: "select",
                        required: true,
                        default: tab,
                        options: [
                            { value: "prohibited", label: "Prohibited" },
                            { value: "preferred", label: "Preferred" },
                        ],
                    },
                    {
                        name: "action",
                        label: "Action",
                        type: "select",
                        required: true,
                        default: tab === "prohibited" ? "block" : "none",
                        options: [
                            { value: "block", label: "Block (prevents saving)" },
                            { value: "warn", label: "Warn (allow with alert)" },
                            { value: "none", label: "None (suggestions only)" },
                        ],
                    },
                    {
                        name: "active",
                        label: "Active",
                        type: "boolean",
                        default: true,
                    },
                ]}
            />
        </div>
    );
};

export default DictionariesPage;
